import { render, staticRenderFns } from "./TextSummary.vue?vue&type=template&id=b07e2790&"
import script from "./TextSummary.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TextSummary.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports